import ApiClient from "../utils/ApiClient";

export default class BaseService {
    protected client: ApiClient;

    constructor(apiClient: ApiClient) {
        this.client = apiClient;
    }
}